// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"79":"component---src-templates-index-tsx","194":"component---src-templates-speech-tsx"}[chunkId] + "-" + {"79":"226a3766ba571f8586ec","194":"bbe1f4d426fd5f036517"}[chunkId] + ".js";
};